export default "__VITE_ASSET__bf1d9778__"